import { POST, GET } from './core';

export const getEndpointWithPrefix = (endpoint) => {
  return `/authentication/${endpoint}`;
};

export const login = (authData) => {
  const endpoint = getEndpointWithPrefix('sign-in');
  const body = {
    ...authData,
  };
  return POST(endpoint, body);
};

export const getUserDetails = (token) => {
  const endpoint = getEndpointWithPrefix('user-details');

  return GET(endpoint, token);
};

export const getMerchantList = (email, token) => {
  const endpoint = getEndpointWithPrefix(`getMerchantList/${email}`);

  return GET(endpoint, token);
};

export const updateAdminAuth = (request, token) => {
  const endpoint = getEndpointWithPrefix('updateAdminAuth');

  return POST(endpoint, request, token);
};

export const registerAdministrator = (request, token) => {
  const endpoint = getEndpointWithPrefix('register-administrator');

  return POST(endpoint, request, token);
};

export const searchAdministrators = (
  token,
  { page = 0, pageSize = 10, email, merchantId } = {}
) => {
  const params = new URLSearchParams();
  params.set('page', page);
  params.set('pageSize', pageSize);
  if (email) params.set('email', email);
  if (merchantId) params.set('merchantId', merchantId);

  const endpoint = getEndpointWithPrefix(
    `search-administrators?${params.toString()}`
  );

  return GET(endpoint, token);
};
